<template>
  <rest-list-page :page-title="pageTitle" :fetch-endpoint="fetchEndpoint">
    <template slot="actions">
      <router-link :to="createRoute" v-if="!readonly">
        <el-button type="primary" icon="el-icon-plus">
          {{ $t('ChannelConfig_AddButton') }}
        </el-button>
      </router-link>
    </template>

    <template slot="table">
      <rest-list-column
        prop="id"
        :title="$t('ChannelConfig_Field_Id')"
        :filterable="true"
        :width="100"
      />

      <rest-list-column-enum
        prop="channel"
        :title="$t('ChannelConfig_Field_Channel')"
        :enum="channelOptionLabel"
        :min-width="300"
      />
      <rest-list-column
        v-if="$isRole('admin')"
        prop="replySupport"
        :title="$t('ChannelConfig_Field_SupportsReplyToMessages')"
        :width="200"
        :filter-input="false"
        :sortable="false"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.replySupport">{{
            $t('ChannelConfig_Yes')
          }}</span>
          <span v-else>{{ $t('ChannelConfig_No') }}</span>
        </template>
      </rest-list-column>
      <rest-list-column
        v-if="$isRole('admin')"
        prop="deliveryReportsSupport"
        :title="$t('ChannelConfig_Field_DeliveryReportsSupport')"
        :width="200"
        :filter-input="false"
        :sortable="false"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.deliveryReportsSupport">{{
            $t('ChannelConfig_Yes')
          }}</span>
          <span v-else>{{ $t('ChannelConfig_No') }}</span>
        </template>
      </rest-list-column>
      <rest-list-column
        v-if="$isRole('admin')"
        prop="otpSupport"
        :title="$t('ChannelConfig_Field_OtpSupport')"
        :width="200"
        :filter-input="false"
        :sortable="false"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.otpSupport">{{ $t('ChannelConfig_Yes') }}</span>
          <span v-else>{{ $t('ChannelConfig_No') }}</span>
        </template>
      </rest-list-column>
      <rest-list-column
        v-if="$isRole('admin')"
        prop="active"
        :title="$t('ChannelConfig_Field_State')"
        :width="80"
        :filter-input="false"
        align="center"
      >
        <template slot-scope="scope">
          <rest-list-action-set-state
            :confirmation-required="
              !!scope.row.active &&
                (!!scope.row.replySupport || !!scope.row.otpSupport)
            "
            :confirmation-title="
              $t('ChannelConfig_Disabling_Confirmation_Title')
            "
            :confirmation-message="disableConfirmaionMessage(scope.row)"
            :confirmation-ok-text="
              $t('ChannelConfig_Disabling_Confirmation_Ok_Text')
            "
            :confirmation-cancel-text="
              $t('ChannelConfig_Disabling_Confirmation_Cancel_Text')
            "
            :endpoint="rowSetStateEndpoint(scope.row)"
            :row-state.sync="scope.row.active"
            reload-project-config
          />
        </template>
      </rest-list-column>

      <rest-list-column-actions>
        <template slot-scope="scope">
          <rest-list-action-update
            v-if="$isRole('admin')"
            :route="rowUpdateRoute(scope.row)"
          />
          <rest-list-action-delete
            v-if="$isRole('admin')"
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="$t(channelOptionLabel[scope.row.channel])"
          />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import { channelOptionLabel } from '@/modules/channels/enum/ChannelEnums'
import RestListPage from '@/common/components/rest/RestListPage'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionUpdate from '@/common/components/rest/RestListActionUpdate'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import RestListActionSetState from '@/common/components/rest/RestListActionSetState'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  components: {
    RestListPage,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnActions,
    RestListActionDelete,
    RestListActionUpdate,
    RestListActionSetState
  },
  data() {
    return {
      channelOptionLabel
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `channel-configs`,
        params: {}
      })
    },

    createRoute() {
      return projectRoute({
        name: 'ChannelCreate'
      })
    },

    readonly() {
      return !this.$isRole('admin')
    }
  },

  methods: {
    rowUpdateRoute(row) {
      return projectRoute({
        name: 'ChannelUpdate',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `channel-configs/${row.id}`
      })
    },

    rowSetStateEndpoint(row) {
      return projectEndpoint({
        method: 'patch',
        url: `channel-configs/${row.id}`
      })
    },

    disableConfirmaionMessage(row) {
      if (row.replySupport && row.otpSupport) {
        return this.$t('ChannelConfig_Disabling_Confirmation_Message_OTP_Reply')
      }
      if (row.otpSupport) {
        return this.$t('ChannelConfig_Disabling_Confirmation_Message_OTP')
      }
      return this.$t('ChannelConfig_Disabling_Confirmation_Message')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/pages/ChannelListPage.vue